import React from 'react';

import logoImg from '../../../assets/img/icons/logo/logo-white-sm.svg';
import { BaseButton, btnTypes } from '../../buttons/baseButton';

import * as ST from './styled';

export interface ILink {
    id?: number,
    title: string,
    path: string,
}

interface IProps {
    links?: ILink[],
    title?: string,
    text?: string,
    btnLink?: ILink,
    bgImage: string,
}

const DEFAULT_TITLE = 'Похоже, что мы потеряли страницу';
const DEFAULT_TEXT = 'К сожалению, запрашиваемую страницу не нашли,\nно есть другие, тоже хорошие:';

const DEFAULT_BTN_LINK: ILink = {
    title: 'Главная',
    path: '/',
};

const DEFAULT_LINKS: ILink[] = [
    {
        id: 1,
        title: 'Личный кабинет',
        path: '/lk',
    },
    {
        id: 2,
        title: 'Помощь',
        path: '/service/search',
    },
];

const Page404: React.FC<IProps> = ({
    links = DEFAULT_LINKS,
    title = DEFAULT_TITLE,
    text = DEFAULT_TEXT,
    btnLink = DEFAULT_BTN_LINK,
    bgImage,
}): JSX.Element => {
    return (
        <ST.Wrapper bgImage={bgImage} data-test='wrapper'>
            <ST.Inner>
                <a href='/'>
                    <ST.Logo data-test='logo' src={logoImg} alt='logo'/>
                </a>
                <ST.ErrorCode data-test='error-code'>404</ST.ErrorCode>
                <ST.Title data-test='title'>{title}</ST.Title>
                <ST.Text data-test='text'>{text}</ST.Text>
                <ST.Navbar data-test='navbar'>
                    {links.map((item) => (<ST.NavItem key={item.id}>
                        <a href={item.path} data-test='navbar-link'>{item.title}</a>
                    </ST.NavItem>))}
                </ST.Navbar>
                <BaseButton
                    text={btnLink.title}
                    href={btnLink.path}
                    type={btnTypes.ACCENT}
                    data-test='main-link-btn'
                />
            </ST.Inner>
        </ST.Wrapper>
    );
};

export default Page404;
